<template>
  <b-form>
    <b-form-group label="Каталог">
      <b-form-select
        v-model="model.catalog"
        :options="[{ id: null, title: 'Нет' }, ...catalogs]"
        text-field="title"
        value-field="id"
        @change="sync()"
      />
    </b-form-group>
    <b-form-group label="Название">
      <b-form-input
        v-model="model.title"
        @change="sync()"
      />
    </b-form-group>
    <b-form-group v-if="!model.id">
      <div class="drop">
        <b-form-file
          ref="browser"
          v-model="model.blob"
          :state="Boolean(model.blob)"
          drop-placeholder="Перетащите файл"
          @input="sync()"
        />
        <p v-if="isInitial">
          Перетащите файл сюда, или кликните на это поле
        </p>
        <p v-if="model.blob">
          {{ model.blob.name }}
        </p>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>

export default {
  name: 'FileForm',
  components: {
  },
  model: {
    prop: 'file',
    event: 'sync'
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    catalogs: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    model: {
      id: null,
      title: '',
      catalog: null,
      blob: null
    },
    error: '',
    prev: {
      title: '',
      blob: null
    }
  }),
  computed: {
    isInitial () {
      return !this.model.blob
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.model = { ...this.model, ...this.file }
    },
    sync () {
      if (!this.model.title && this.model.blob) {
        this.model.title = this.model.blob.name
      }

      this.$emit('sync', this.model)
    }
  }
}
</script>

<style lang="scss">
.drop {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;

  &:hover {
    background: lightblue;
  }

  p {
    font-size: 1.2em;
    text-align: center;
    padding: 2.5rem 0 4rem;
  }

  .b-form-file {
    opacity: 0; /* invisible but it's there! */
  }

  input {
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
}
</style>
